<template>
    <div
        :class="{
            blur: editTarget,
            'bg-white': !editTarget && !target.is_flagged,
            'is-flagged': target.is_flagged,
        }"
    >
        <component
            v-if="
                [
                    'articulation',
                    'duration',
                    'mand',
                    'mand_echoic',
                    'multi_tally',
                    'percent',
                ].includes(trackerMethodType)
            "
            :is="`tracker-data-${trackerMethodType.replace('_', '-')}`"
            @delete-tracker="removeTracker()"
            @edit-target="$emit('edit-target', $event)"
            @close-details="closeDetailsEdit()"
        ></component>

        <div
            class="row pl-3 pr-1 data-row mx-0"
            :style="rowDetail ? 'border-bottom: none' : ''"
            v-else=""
        >
            <!--TODO: remove-->
            <div class="px-1 col-2">
                <div class="d-flex justify-content-start align-items-center">
                    <span class="mr-2">{{ moment(target.session_at).format("MM/DD/YYYY") }}</span>
                    <profile-picture
                        v-if="target.created_by_user"
                        :name="target.created_by_user.name"
                        :size="'sm'"
                        :url="target.created_by_user.profile_photo_url"
                    ></profile-picture>
                </div>
            </div>

            <template v-if="trackerMethodType === 'tally'">
                <div class="px-1 col-2">
                    <small>{{ target.data.success }}</small>
                </div>
                <div class="px-1 col-2">
                    <small>{{ success }}</small>
                </div>
                <div class="px-1 col-5">
                    <small
                        ><span
                            v-if="isBaseline"
                            class="font-weight-bold text-uppercase text-primary"
                            >Baseline</span
                        >
                        {{ target.notes ? target.notes : "none" }}</small
                    >
                </div>
            </template>

            <template v-if="trackerMethodType === 'time_sampling'">
                <div class="px-1 col-2">
                    <small>{{ target.data.success }}</small>
                </div>
                <div class="px-1 col-2">
                    <small>{{ success }}</small>
                </div>
                <div class="px-1 col-5">
                    <small
                        ><span
                            v-if="isBaseline"
                            class="font-weight-bold text-uppercase text-primary"
                            >Baseline</span
                        >
                        {{ target.notes ? target.notes : "none" }}</small
                    >
                </div>
            </template>

            <template v-if="trackerMethodType === 'preference_assessment_single'">
                <div class="col-9">
                    <div
                        class="row"
                        v-for="(k, i) in Object.keys(helpers._get(target, 'data.items', {}))"
                        :key="i"
                    >
                        <div class="px-1 col-2">
                            <small>{{ k }}</small>
                        </div>
                        <div class="px-1 col-2">
                            <small>{{
                                moment()
                                    .startOf("day")
                                    .seconds(target.data.items[k].duration || 0)
                                    .format("H:mm:ss")
                            }}</small>
                        </div>
                        <div class="px-1 col-5">
                            <small v-if="i === 0"
                                ><span
                                    v-if="isBaseline"
                                    class="font-weight-bold text-uppercase text-primary"
                                    >Baseline</span
                                >
                                {{ target.notes }}</small
                            >
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="trackerMethodType === 'preference_assessment_paired'">
                <div class="col-9">
                    <div
                        class="row"
                        v-for="(k, i) in Object.keys(helpers._get(target, 'data.items', {}))"
                        :key="i"
                    >
                        <div class="px-1 col-2">
                            <small>{{ k }}</small>
                        </div>
                        <div class="px-1 col-2">
                            <small>{{ target.data.items[k].selected }}</small>
                        </div>
                        <div class="px-1 col-2">
                            <small>{{ target.data.items[k].presented }}</small>
                        </div>
                        <div class="px-1 col-1">
                            <small
                                >{{
                                    target.data.items[k].presented
                                        ? parseInt(
                                              (target.data.items[k].selected /
                                                  target.data.items[k].presented) *
                                                  100
                                          )
                                        : "0"
                                }}%</small
                            >
                        </div>
                        <div class="px-1 col-5">
                            <small v-if="i === 0"
                                ><span
                                    v-if="isBaseline"
                                    class="font-weight-bold text-uppercase text-primary"
                                    >Baseline</span
                                >
                                {{ target.notes }}</small
                            >
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="trackerMethodType === 'preference_assessment_mswo'">
                <div class="col-9">
                    <div
                        class="row"
                        v-for="(k, i) in Object.keys(helpers._get(target, 'data.items', {}))"
                        :key="i"
                    >
                        <div class="px-1 col-3">
                            <small>{{ k }}</small>
                        </div>
                        <div class="px-1 col-3">
                            <small>{{
                                target.data.items[k].points
                                    ? target.data.items[k].points
                                    : "Not selected"
                            }}</small>
                        </div>
                        <div class="px-1 col-6">
                            <small v-if="i === 0"
                                ><span
                                    v-if="isBaseline"
                                    class="font-weight-bold text-uppercase text-primary"
                                    >Baseline</span
                                >
                                {{ target.notes }}</small
                            >
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="trackerMethodType === 'preference_assessment_msw'">
                <div class="col-9">
                    <div
                        class="row"
                        v-for="(k, i) in Object.keys(helpers._get(target, 'data.items', {}))"
                        :key="i"
                    >
                        <div class="px-1 col-2">
                            <small>{{ k }}</small>
                        </div>
                        <div class="px-1 col-2">
                            <small>{{ target.data.items[k].selected }}</small>
                        </div>
                        <div class="px-1 col-2">
                            <small>{{ target.data.items[k].presented }}</small>
                        </div>
                        <div class="px-1 col-1">
                            <small
                                >{{
                                    target.data.items[k].presented
                                        ? parseInt(
                                              (target.data.items[k].selected /
                                                  target.data.items[k].presented) *
                                                  100
                                          )
                                        : 0
                                }}%</small
                            >
                        </div>
                        <div class="px-1 col-5">
                            <small v-if="i === 0"
                                ><span
                                    v-if="isBaseline"
                                    class="font-weight-bold text-uppercase text-primary"
                                    >Baseline</span
                                >
                                {{ target.notes }}</small
                            >
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="trackerMethodType === 'preference_assessment_free_operant'">
                <div class="col-9">
                    <div
                        class="row"
                        v-for="(k, i) in Object.keys(helpers._get(target, 'data.items', {}))"
                        :key="i"
                    >
                        <div class="px-1 col-3">
                            <small>{{ k }}</small>
                        </div>
                        <div class="px-1 col-3">
                            <small>{{ target.data.items[k].selected }}</small>
                        </div>
                        <div class="px-1 col-3">
                            <small>{{
                                moment()
                                    .startOf("day")
                                    .seconds(target.data.items[k].duration || 0)
                                    .format("H:mm:ss")
                            }}</small>
                        </div>
                        <div class="px-1 col-3">
                            <small v-if="i === 0"
                                ><span
                                    v-if="isBaseline"
                                    class="font-weight-bold text-uppercase text-primary"
                                    >Baseline</span
                                >
                                {{ target.notes }}</small
                            >
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="trackerMethodType === 'cme'">
                <div class="px-1 col-4">
                    <small
                        >{{ target.data.success }}
                        <i
                            v-if="target.data.hasOwnProperty('scores')"
                            class="cursor-pointer text-primary fa fa-lg fa-caret-right"
                            :class="{ 'rot-90': rowDetail }"
                            @click="rowDetail = !rowDetail"
                        ></i
                    ></small>
                    <p class="mb-0" v-if="rowDetail">
                        <small
                            >Scores:
                            <span v-for="s in target.data.scores" class="score">{{
                                s
                            }}</span></small
                        >
                    </p>
                </div>
                <div class="px-1 col-5">
                    <small
                        ><span
                            v-if="isBaseline"
                            class="font-weight-bold text-uppercase text-primary"
                            >Baseline</span
                        >
                        {{ target.notes ? target.notes : "none" }}</small
                    >
                </div>
            </template>

            <template v-if="trackerMethodType === 'multi_percent'">
                <div class="px-1 col-2">
                    <small
                        >{{ target.data.success }} %
                        <i
                            v-if="target.data.hasOwnProperty('results')"
                            class="cursor-pointer text-primary fa fa-lg fa-caret-right"
                            :class="{ 'rot-90': rowDetail }"
                            @click="rowDetail = !rowDetail"
                        ></i
                    ></small>
                </div>
                <div class="px-1 col-7">
                    <small
                        ><span
                            v-if="isBaseline"
                            class="font-weight-bold text-uppercase text-primary"
                            >Baseline</span
                        >
                        {{ target.notes ? target.notes : "none" }}</small
                    >
                </div>
            </template>

            <template v-if="trackerMethodType === 'task_analysis'">
                <div class="px-1 col-2">
                    <template
                        v-if="
                            target.is_manual_entry ||
                                !helpers._get(target.data, 'results', []).length
                        "
                    >
                        <small>{{
                            Math.round((goal.parameters.steps.length * target.data.success) / 100)
                        }}</small>
                    </template>
                    <template v-else="">
                        <small>{{ target.data.correct }}</small>
                        <i
                            class="ml-2 fa fa-caret-right cursor-pointer text-primary"
                            style="transition: all 0.4s;"
                            :class="{ 'rot-90': rowDetail }"
                            @click="rowDetail = !rowDetail"
                        ></i>
                    </template>
                </div>
                <div class="px-1 col-2">
                    <template
                        v-if="
                            target.is_manual_entry ||
                                !helpers._get(target.data, 'results', []).length
                        "
                    >
                        <small>{{ goal.parameters.steps.length }}</small>
                    </template>
                    <template v-else="">
                        <small>{{ helpers._get(target.data, "results", []).length }}</small>
                    </template>
                </div>
                <div class="px-1 col-2">
                    <small>{{ target.data.success }}%</small>
                </div>
                <div class="px-1 col-3">
                    <small
                        ><span
                            v-if="isBaseline"
                            class="font-weight-bold text-uppercase text-primary"
                            >Baseline</span
                        >
                        {{ target.notes ? target.notes : "none" }}</small
                    >
                </div>
            </template>

            <div class="px-1 pt-1 col-1" v-if="canTrackManually">
                <data-actions
                    @delete-tracker="removeTracker()"
                    @edit-target="$emit('edit-target', $event)"
                    @close-details="closeDetailsEdit()"
                ></data-actions>
            </div>
        </div>

        <div class="row pl-3 pr-1 data-row mx-0" v-if="rowDetail" style="border-top:none;">
            <template v-if="trackerMethodType === 'multi_percent'">
                <div class="px-1 col-2 offset-2">
                    <span
                        class="d-flex"
                        v-for="(key, targetIndex) in multiPercentTargetDataDetailedResultsKeys"
                    >
                        <small class="text-nowrap mr-2 mb-3"
                            >{{ targetIndex + 1 }}. {{ key }}</small
                        >
                        <span class="d-flex">
                            <span
                                class="mx-1"
                                v-for="(result, resultIndex) in target.data.detailed_results[key]"
                            >
                                <prompt
                                    :key="`t${targetIndex}r${resultIndex}`"
                                    :mini="true"
                                    :prompt="[null, iconset, parseInt(result)]"
                                ></prompt>
                            </span>
                        </span>
                        <span>{{ getPercentRate(target.data.results[key]) }}</span>

                        <br />
                    </span>
                </div>
            </template>

            <template v-if="trackerMethodType === 'task_analysis'">
                <div class="col-12">
                    <div class="row">
                        <div class="col-1">
                            <small><b>Step</b></small>
                        </div>
                        <div class="col-2">
                            <small><b>Prompt</b></small>
                        </div>
                    </div>
                    <div class="row" v-for="(r, i) in target.data.detailed_results">
                        <div class="col-1">
                            <small>{{ i + 1 }}.</small>
                        </div>
                        <div class="col-2 ">
                            <prompt :mini="true" :prompt="[null, iconset, r]"></prompt>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import DataActions from "./tracker-data/DataActions";
import Prompt from "../ui/PromptIcon";
import ProfilePicture from "../ui/ProfilePicture";
import TrackerDataArticulation from "./tracker-data/TrackerDataArticulation";
import TrackerDataDuration from "./tracker-data/TrackerDataDuration";
import TrackerDataMand from "./tracker-data/TrackerDataMand";
import TrackerDataMandEchoic from "./tracker-data/TrackerDataMandEchoic";
import TrackerDataMultiTally from "./tracker-data/TrackerDataMultiTally";
import TrackerDataPercent from "./tracker-data/TrackerDataPercent";
import { permissions } from "../../plugins/permissions";
import { helpers } from "../../plugins/helpers";

export default {
    name: "GoalsData",
    props: [
        "goal",
        "userId",
        "patientId",
        "target",
        "success",
        "type",
        "editTarget",
        "isBaseline",
        "customization",
    ],
    components: {
        DataActions,
        Prompt,
        ProfilePicture,
        TrackerDataArticulation,
        TrackerDataDuration,
        TrackerDataMand,
        TrackerDataMandEchoic,
        TrackerDataMultiTally,
        TrackerDataPercent,
    },
    mixins: [permissions],
    provide: function() {
        return {
            goal: this.goal,
            target: this.target,
            isBaseline: this.isBaseline,
            iconset: this.iconset,
        };
    },
    data() {
        return {
            helpers,
            enteringData: false,
            rowDetail: false,
            deleteConfirmation: false,
            data: [],
        };
    },
    computed: {
        iconset() {
            if (this.target && this.target.data && !isNaN(this.target.data.iconset)) {
                return this.target.data.iconset;
            }
            return this.customization &&
                this.customization.default_options &&
                !isNaN(this.customization.default_options.iconset)
                ? this.customization.default_options.iconset
                : 0;
        },
        trackerMethodType() {
            if (this.goal.tracker_type === "preference_assessment") {
                return `preference_assessment_${this.goal.parameters.method}`;
            } else {
                return this.goal.tracker_type;
            }
        },
        multiPercentTargetDataDetailedResultsKeys() {
            if (
                _.get(this.target, "data.detailed_results", false) &&
                typeof this.target.data.detailed_results === "object"
            ) {
                return Object.keys(this.target.data.detailed_results);
            }
            return [];
        },
        userCanDeleteTracker() {
            switch (_.get(this.$root, "organization.type", null)) {
                case "professional_silver":
                    return (
                        this.goal.created_by_user.id === this.userId ||
                        this.tracker.created_by_user.id === this.userId
                    );
                case "professional_gold":
                case "professional_platinum":
                    return this.canTrackManually;
            }
        },
    },
    methods: {
        removeTracker() {
            axios
                .delete(
                    `/api/patients/${this.patientId}/goals/${this.goal.id}/trackers/${
                        this.target.id
                    }`
                )
                .then(response => {
                    this.closeConfirmDelete();
                    this.$emit("refresh-trackers");
                });
        },
        isTaskSuccess(step) {
            return step === 3;
        },

        confirmDelete() {
            this.deleteConfirmation = true;
        },
        closeConfirmDelete() {
            this.$set(this, "deleteConfirmation", false);
        },
        closeDetailsEdit() {
            this.rowDetail = false;
            this.$emit("edit-target", this.target);
        },
        getPercentRate(array) {
            if (Array.isArray(array) && array.length) {
                return (
                    parseInt((100 * array.reduce((cur, agg) => agg + cur, 0)) / array.length) + "%"
                );
            }
            return "0%";
        },
    },
};
</script>

<style scoped lang="scss">
.data-row {
    border: solid 1px #8f8f8f;
    border-bottom: none;
}
.data-row:last-child {
    border: solid 1px #8f8f8f;
}

.score:not(:last-child):after {
    content: ", ";
}
.line {
    border: solid 1px #8f8f8f;
}
div.flagged {
    background-color: #fcf8ed;
}
small.flagged {
    color: #ff0000;
    font-weight: 600;
}
</style>
